module.exports = __webpack_public_path__ + "static/media/aladdin.88f42cbb.jpg";